import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import EntityContainer from "../../components/EntertainmentEntityManagement/CreateUpdateEntertainmentEntity/EntityContainer";
import { getArtistsRequest, getEntityGlobalsRequest, createEntityRequest, updateEntityRequest, deleteEntityRequest, getEntityRequest, clearEntityData } from '../../redux/actions/getEntity';
import { toast } from "react-toastify";
import api_service from "../../network/api_callbacks";
import ProgressModal from "../../utility/ProgressModal";
import { set } from "react-hook-form";

const CreateEntertainmentEntity = (props) => {

    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state;
    const isNestedRoute = location.pathname !== "/entertainment-entity-management/create-entertainment-entity";
    console.log("location.pathname : ", location.pathname);
    const [editableEntityData, setEditableEntityData] = useState(null);
    const [editableEntityMultimediaData, setEditableEntityMultimediaData] = useState(null);
    const [entertainment_entity_filter, setEntertainment_entity_filter] = useState(null);
    const [action, setAction] = useState(null);
    const [artists, setArtists] = useState([]);
    const [loader, setLoader] = useState(false);
    const [isReferesh, setIsRefresh] = useState(false);

    const getEntityDetails = (entityId) => {
        if (!entityId || typeof entityId !== "string" || entityId?.trim() === "") return null;
        props?.getEntity(entityId);
    }

    const getMultiMediaByEntityId = async (entityId) => {
         if (!entityId || typeof entityId !== "string" || entityId?.trim() === "") return null;
        try {
            const response = await api_service.getMultiMediaList(entityId);
            setEditableEntityMultimediaData(response?.[0]?.data || []);
            // setIsRefresh(false);
            console.log('📘 Multimedia Data:', response?.[0]?.data);
        } catch (error) {
            console.error('❌ Failed to fetch Multimedia:', error);
        }
    }

    useEffect(() => {
        if (props?.ENTITY_DATA && state?.entity_data?._id) {
            console.log("ENTITY_DATA : ", props?.ENTITY_DATA);
            setEditableEntityData(props?.ENTITY_DATA);
        }
    }, [props?.ENTITY_DATA]);

    useEffect(() => {
        console.log("state : ", state)
        if (state?.shouldRefresh && isReferesh === false) {
            console.log("fetching artists : 3")
            getEntityDetails(state?.entity_data?._id);
            getMultiMediaByEntityId(state?.entity_data?._id);
            props?.getArtists({ show: 'all', type: 'artist' });
            setIsRefresh(true);
        }
        else if (state?.shouldRefresh && isReferesh === true && editableEntityData && editableEntityMultimediaData && artists.length > 0) {
            console.log("No need to refresh data.")
            setIsRefresh(false);
        }
        else {
            console.log("fetching artists : 4")
            if (!editableEntityData && state?.entity_data?._id) {
                console.log("entity_data : ", state?.entity_data);
                getEntityDetails(state?.entity_data?._id);
                //setEditableEntityData(state?.entity_data);

                const entity_artist =
                {
                    "_id": "6891d60a0ad9f6069e94d83d",
                    "type": "artist",
                    "displayName": "Arijit",
                    "multimedia": [
                        {
                            "mediaType": "image",
                            "imageType": "avatar",
                            "url": "https://picsum.photos/seed/picsum/200/200",
                            "aspectRatio": "1:1"
                        },
                        {
                            "mediaType": "image",
                            "imageType": "thumbnail",
                            "url": "https://fastly.picsum.photos/id/382/200/200.jpg?grayscale&hmac=nRBLVgtebwvxOK2CtQnJIkuQiIAiJkXpiSG_GrdIsg4",
                            "aspectRatio": "3:4"
                        },
                        {
                            "mediaType": "image",
                            "imageType": "banner",
                            "url": "https://picsum.photos/id/237/200/200",
                            "aspectRatio": "1:2"
                        }
                    ],
                    "tags": [
                        {
                            "type": "songGenre",
                            "details": {
                                "genreName": "action"
                            }
                        }
                    ],
                    "metadata": {
                        "artists": [

                        ],
                        "artistType": "singer",
                        "isSuperStar": false,
                        "industry": [
                            "bollywood"
                        ]
                    },
                    "created_at": "2025-08-05T09:59:38.218Z",
                    "updated_at": "2025-08-05T09:59:38.218Z",
                    "__v": 0
                }

                const entity_song =
                {
                    "type": "song",
                    "displayName": "WavesofSilence",
                    "multimedia": [
                        {
                            "mediaType": "image",
                            "imageType": "thumbnail",
                            "url": "https://image-bucket-nexiantian.s3.ap-south-1.amazonaws.com/actor+photo/gulam.png",
                            "aspectRatio": "16: 9"
                        }
                    ],
                    "tags": [
                        {
                            "type": "songGenre",
                            "details": {
                                "genreName": "action",
                                "_id": "68908bb445b4d085eba1f39b"
                            }
                        }
                    ],
                    "metadata": {
                        "year": 2024,
                        "duration": 228,
                        "label": "SaReGaMAIndiaLtd",
                        "language": "hi",
                        "country": "in",
                        "industry": "tollywood_telugu",
                        "artistType": "singer",
                        "artists": ["6890955131f40a8148e58b83"]
                    }
                }

                const entity_movie =
                {
                    "type": "movie",
                    "displayName": "WavesofSilence",
                    "multimedia": [
                        {
                            "mediaType": "image",
                            "imageType": "thumbnail",
                            "url": "https://image-bucket-nexiantian.s3.ap-south-1.amazonaws.com/actor+photo/gulam.png",
                            "aspectRatio": "16: 9"
                        }
                    ],
                    "tags": [
                        {
                            "type": "movie_genre",
                            "details": {
                                "genreName": "action",
                                "_id": "68908bb445b4d085eba1f39b"
                            }
                        },
                        {
                            "type": "movie_genre",
                            "details": {
                                "genreName": "romance",
                                "_id": "68908bb445b4d085eba1f39b"
                            }
                        }
                    ],
                    "metadata": {
                        "language": "hi",
                        "country": "in",
                        "industry": "tollywood_telugu",
                        "artistType": "singer",
                        "year": 2024,
                        "released": "24Aug2014",
                        "plot": "SaReGaMAIndiaLtd",
                        "duration": 228,
                        "artists": ["689339213bc9140733a76482"]
                    }
                }

                //setEditableEntityData(entity_movie);
            }
            if (!editableEntityMultimediaData && state?.entity_data?._id) {
                getMultiMediaByEntityId(state?.entity_data?._id);
            }
            if (!entertainment_entity_filter && state?.entertainment_entity_filter) {
                setEntertainment_entity_filter(state?.entertainment_entity_filter);
            }
            if (!props?.ARTISTS_DATA) {
                console.log("fetching artists : 1")
                props?.getArtists({ show: 'all', type: 'artist' });
            }
            // else {
            //     console.log("fetching artists : 2")
            //     props?.getArtists({ show: 'all', type: 'artist' });
            // }
        }

        console.log("editableEntityMultimediaData : ", editableEntityMultimediaData);
    }, [editableEntityData, editableEntityMultimediaData, state?.entity_data, state?.shouldRefresh, state?.entertainment_entity_filter]);

    useEffect(() => {
        console.log("action : ", action)
        console.log("CREATE_ENTITY_DATA : ", props?.CREATE_ENTITY_DATA)
        console.log("CREATE_ENTITY_ERROR : ", props?.CREATE_ENTITY_ERROR)
        if (action) {
            if (props?.CREATE_ENTITY_DATA && !props?.CREATE_ENTITY_DATA?.error) {
                console.log("step : 1")
                handleBackToEntertainmentEntityManagement(true, props?.CREATE_ENTITY_DATA)
            }
            else if (props?.UPDATE_ENTITY_DATA && !props?.UPDATE_ENTITY_DATA?.error) {
                console.log("step : 2")
                handleBackToEntertainmentEntityManagement(true, props?.UPDATE_ENTITY_DATA)
            }
            else if (props?.DELETE_ENTITY_DATA && !props?.DELETE_ENTITY_DATA?.error) {
                console.log("step : 3")
                handleBackToEntertainmentEntityManagement(true, props?.DELETE_ENTITY_DATA)
            }
            else if (props?.CREATE_ENTITY_ERROR || props?.UPDATE_ENTITY_ERROR || (props?.DELETE_ENTITY_ERROR || props?.DELETE_ENTITY_DATA?.error)) {
                console.log("step : 4")
                toast.error(`${(props?.CREATE_ENTITY_ERROR || props?.CREATE_ENTITY_ERROR?.error?.message) || (props?.UPDATE_ENTITY_ERROR || props?.UPDATE_ENTITY_ERROR?.error?.message) || (props?.DELETE_ENTITY_ERROR?.message || props?.DELETE_ENTITY_DATA?.error?.message)}`)
            }
            else {
                console.log("step : 5")
            }
        }
        else {
            console.log("step : 6")
        }
    }, [
        props?.CREATE_ENTITY_DATA,
        props?.CREATE_ENTITY_ERROR,
        props?.UPDATE_ENTITY_DATA,
        props?.UPDATE_ENTITY_ERROR,
        props?.DELETE_ENTITY_DATA,
        props?.DELETE_ENTITY_ERROR,
    ])

    useEffect(() => {
        if (props?.ARTISTS_DATA) {
        setArtists(props.ARTISTS_DATA);
    }
    }, [props?.ARTISTS_DATA])

    const createQuestions = async (entity) => {
        try {
            setLoader(true);
            const response = await api_service.createQuestionsBankForEntity({ eeId: entity?._id });
            setLoader(false);
            console.log('📘 Question Bank Data:', response);
            toast.success(`${response?.data?.questionCount} Questions Created for entity ${response?.data?.movieInfo?.name}`)
            handleBackToEntertainmentEntityManagement(false, response?.data)
        } catch (error) {
            setLoader(false);
            console.error('❌ Failed to fetch Question Bank:', error);
        }
    }

    const handleBackToEntertainmentEntityManagement = (isReferesh, actionData) => {
        console.log("handleBackToEntertainmentEntityManagement : ", actionData);
        setAction(null);
        navigate('/entertainment-entity-management', {
            state: {
                from: 'create-entertainment-entity',
                actionData: actionData,
                shouldRefresh: isReferesh,
            }
        });
    };

    const isValidate = (action, editableEntityData) => {
        if (action === 'delete') {

        } else if (action === 'create') {

        } else if (action === 'update') {

        }
        return true;
    }

    const callApis = (action, editableEntityData) => {
        console.log("action api => ", editableEntityData?._id)
        console.log("action api => ", editableEntityData)
        if (action === 'delete') {
            props?.deleteEntity(editableEntityData?._id);
        } else if (action === 'create') {
            props?.createEntity(editableEntityData);
        } else if (action === 'update') {
            props?.updateEntity(editableEntityData);
        }
    }

    const handleEntityCTAButtonsClick = (action) => {
        setAction(action);
        if (action === 'delete') {
            const isValid = isValidate(action, editableEntityData)
            if (isValid) {
                callApis(action, editableEntityData);
            }
        } else if (action === 'create') {
            const isValid = isValidate(action, editableEntityData)
            if (isValid) {
                callApis(action, editableEntityData);
            }
        } else if (action === 'update') {
            const isValid = isValidate(action, editableEntityData)
            if (isValid) {
                callApis(action, editableEntityData);
            }
        }
    }

    return (
        isNestedRoute ? (
            <div style={{
                flex: 1,
                marginTop: '0px',
                marginLeft: '0px',
                padding: '0px 0px 0px 0px',
                textAlign: 'center',
                width: '100%',
                height: '100%',
            }}>
                <Outlet />
            </div>
        ) : (
            <>
                <div style={{
                    flex: 1,
                    marginTop: '30px',
                    marginLeft: '0px',
                    padding: '0px 0px 0px 0px',
                    textAlign: 'center',
                    width: '100%',
                    height: '100%',
                }}>
                    <EntityContainer
                        editableEntityData={editableEntityData}
                        setEditableEntityData={setEditableEntityData}
                        entertainment_entity_filter={entertainment_entity_filter}
                        artists={artists}
                        handleEntityCTAButtonsClick={handleEntityCTAButtonsClick}
                        createQuestions={createQuestions}
                        getMultiMediaByEntityId={getMultiMediaByEntityId}
                        editableEntityMultimediaData={editableEntityMultimediaData}
                    />
                </div>
                {(loader) && <ProgressModal open={loader} isLoader={loader} progress={0} title="OpenAI creating questions..." />}
            </>
        )
    )
}

const mapStateToProps = (state) => {
    return {
        ARTISTS_LOADING: state?.getEntity?.artists_loading,
        ARTISTS_ERROR: state?.getEntity?.artists_error,
        ARTISTS_DATA: state?.getEntity?.artists_data,

        ENTITY_GLOBALS_LOADING: state?.getEntity?.entity_globals_loading,
        ENTITY_GLOBALS_DATA: state?.getEntity?.entity_globals_data,
        ENTITY_GLOBALS_ERROR: state?.getEntity?.entity_globals_error,

        ENTITY_LOADING: state?.getEntity?.entity_loading,
        ENTITY_ERROR: state?.getEntity?.entity_error,
        ENTITY_DATA: state?.getEntity?.entity_data,

        CREATE_ENTITY_LOADING: state?.getEntity?.create_entity_loading,
        CREATE_ENTITY_ERROR: state?.getEntity?.create_entity_error,
        CREATE_ENTITY_DATA: state?.getEntity?.create_entity_data,

        UPDATE_ENTITY_LOADING: state?.getEntity?.update_entity_loading,
        UPDATE_ENTITY_ERROR: state?.getEntity?.update_entity_error,
        UPDATE_ENTITY_DATA: state?.getEntity?.update_entity_data,

        DELETE_ENTITY_LOADING: state?.getEntity?.delete_entity_loading,
        DELETE_ENTITY_ERROR: state?.getEntity?.delete_entity_error,
        DELETE_ENTITY_DATA: state?.getEntity?.delete_entity_data,
    }
};

const mapDispatchToProps = {
    getEntity: getEntityRequest,
    createEntity: createEntityRequest,
    updateEntity: updateEntityRequest,
    deleteEntity: deleteEntityRequest,
    getArtists: getArtistsRequest,
    getEntityGlobals: getEntityGlobalsRequest,
    clearEntityData,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateEntertainmentEntity)